/* ilico-mobile-qty — quantity = absolutní počet v košíku */
(function() {
  var cartQty = {}; /* variant_id → quantity v košíku */

  /* Načti aktuální košík a nastav dropdowny */
  function syncFromCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cartQty = {};
        cart.items.forEach(function(item) {
          cartQty[item.variant_id] = (cartQty[item.variant_id] || 0) + item.quantity;
        });
        updateAllDropdowns();
      })
      .catch(function() {});
  }

  function updateAllDropdowns() {
    document.querySelectorAll('[data-mob-qty-select]').forEach(function(sel) {
      var form = sel.closest('form');
      if (!form) return;
      var vid = form.querySelector('input[name="id"]');
      if (!vid) return;
      var id = parseInt(vid.value);
      var inCart = cartQty[id] || 0;
      var label = sel.closest('.ilico-mob-qty-row').querySelector('.ilico-mob-qty-label');
      if (inCart > 0) {
        sel.value = String(inCart);
        label.textContent = inCart + ' ks';
      } else {
        sel.value = '1';
        label.textContent = '1 ks';
      }
    });
  }

  /* Při načtení stránky */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromCart);
  } else {
    syncFromCart();
  }

  /* 1. Dropdown change: aktualizuj label */
  document.addEventListener('change', function(e) {
    var sel = e.target.closest('[data-mob-qty-select]');
    if (!sel) return;
    var label = sel.closest('.ilico-mob-qty-row').querySelector('.ilico-mob-qty-label');
    label.textContent = (parseInt(sel.value) || 1) + ' ks';
  });

  /* 2. Klik na cart button → /cart/update.js s absolutním počtem */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-mob-cart-btn]');
    if (!btn || btn.disabled) return;
    var row = btn.closest('.ilico-mob-qty-row');
    if (!row) return;

    /* Variant ID: buď z formu (single-variant), nebo z data atributu (multi-variant) */
    var vid;
    var form = btn.closest('form');
    if (form && form.querySelector('input[name="id"]')) {
      vid = parseInt(form.querySelector('input[name="id"]').value);
    } else if (btn.dataset.mobVariantId) {
      vid = parseInt(btn.dataset.mobVariantId);
    } else {
      var actionsEl = btn.closest('.card-product-actions');
      if (actionsEl && actionsEl.dataset.variantId) {
        vid = parseInt(actionsEl.dataset.variantId);
      } else {
        var selEl = row.querySelector('[data-variant-id]');
        if (selEl) vid = parseInt(selEl.dataset.variantId);
      }
    }
    if (!vid) return;

    var sel = row.querySelector('[data-mob-qty-select]');
    var desiredQty = parseInt(sel.value) || 1;
    var currentQty = cartQty[vid] || 0;

    /* Pokud je desired stejné jako v košíku, nic nedělej */
    if (desiredQty === currentQty) return;

    btn.classList.add('ilico-mob-loading');
    btn.disabled = true;

    var updates = {};
    updates[vid] = desiredQty;

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      /* Aktualizuj lokální stav */
      cartQty = {};
      cart.items.forEach(function(item) {
        cartQty[item.variant_id] = (cartQty[item.variant_id] || 0) + item.quantity;
      });

      /* Aktualizuj mini-cart (sections) */
      var minicart = document.querySelector('mini-cart');
      if (minicart) minicart.updateSectionContents();

      /* Aktualizuj header cart count badge */
      var countBubbles = document.querySelectorAll('.header-mini-cart-count, .cart-count-bubble span');
      countBubbles.forEach(function(el) {
        var total = 0;
        cart.items.forEach(function(i) { total += i.quantity; });
        el.textContent = total;
      });

      /* Feedback: fajfka */
      btn.classList.remove('ilico-mob-loading');
      btn.classList.add('ilico-mob-added');
      btn.disabled = false;
      clearTimeout(btn._mobT);
      btn._mobT = setTimeout(function() {
        btn.classList.remove('ilico-mob-added');
      }, 1500);

      /* Dispatch event pro ostatní listenery */
      document.dispatchEvent(new CustomEvent('cart:item-add', {
        detail: { context: 'MobileQtyUpdate' }
      }));
    })
    .catch(function() {
      btn.classList.remove('ilico-mob-loading');
      btn.disabled = false;
    });
  });

  /* 3. Po jakékoliv cart změně (i z jiného místa) přenačti stav */
  document.addEventListener('cart:item-add', function(e) {
    if (e.detail && e.detail.context === 'MobileQtyUpdate') return;
    setTimeout(syncFromCart, 500);
  });
})();

/* ── Scroll wrapper + šipky pro size/color badges ── */
(function() {
  if (window.innerWidth > 749) return;

  function wrapScrollable(selector) {
    document.querySelectorAll(selector).forEach(function(el) {
      /* Přeskoč pokud už je obaleno */
      if (el.parentElement && el.parentElement.classList.contains('ilico-scroll-wrap')) return;

      var wrap = document.createElement('div');
      wrap.className = 'ilico-scroll-wrap';

      var arrowL = document.createElement('span');
      arrowL.className = 'ilico-scroll-arrow ilico-arrow-left';
      arrowL.innerHTML = '\u2039';

      var arrowR = document.createElement('span');
      arrowR.className = 'ilico-scroll-arrow ilico-arrow-right';
      arrowR.innerHTML = '\u203A';

      el.parentNode.insertBefore(wrap, el);
      wrap.appendChild(arrowL);
      wrap.appendChild(el);
      wrap.appendChild(arrowR);

      arrowL.addEventListener('click', function() {
        el.scrollBy({ left: -80, behavior: 'smooth' });
      });
      arrowR.addEventListener('click', function() {
        el.scrollBy({ left: 80, behavior: 'smooth' });
      });

      updateArrows(wrap, el);
      createDots(wrap, el);

      el.addEventListener('scroll', function() {
        updateArrows(wrap, el);
        updateDots(wrap, el);
      });
    });
  }

  function updateArrows(wrap, el) {
    var canLeft = el.scrollLeft > 3;
    var canRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 3;

    if (canLeft) wrap.classList.add('ilico-can-left');
    else wrap.classList.remove('ilico-can-left');

    if (canRight) wrap.classList.add('ilico-can-right');
    else wrap.classList.remove('ilico-can-right');
  }

  function createDots(wrap, el) {
    var items = el.querySelectorAll('.ilico-size-badge, .ilico-color-swatch');
    if (items.length < 2) return;
    if (el.scrollWidth <= el.clientWidth + 3) return;

    var MAX_DOTS = 5;
    var numDots = Math.min(items.length, MAX_DOTS);
    var maxScroll = el.scrollWidth - el.clientWidth;

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'ilico-scroll-dots';
    dotsWrap.dataset.numDots = numDots;
    dotsWrap.dataset.maxScroll = maxScroll;
    for (var i = 0; i < numDots; i++) {
      var dot = document.createElement('button');
      dot.className = 'ilico-scroll-dot';
      dot.type = 'button';
      dot.dataset.index = i;
      dot.addEventListener('click', (function(idx, nd, ms) {
        return function() {
          var targetScroll = nd <= 1 ? 0 : (ms * idx / (nd - 1));
          el.scrollTo({ left: targetScroll, behavior: 'smooth' });
        };
      })(i, numDots, maxScroll));
      dotsWrap.appendChild(dot);
    }
    wrap.parentNode.insertBefore(dotsWrap, wrap.nextSibling);
    updateDots(wrap, el);
  }

  function updateDots(wrap, el) {
    var dotsWrap = wrap.nextElementSibling;
    if (!dotsWrap || !dotsWrap.classList.contains('ilico-scroll-dots')) return;
    var dots = dotsWrap.querySelectorAll('.ilico-scroll-dot');
    var numDots = dots.length;
    if (numDots < 1) return;
    var maxScroll = el.scrollWidth - el.clientWidth;
    var progress = maxScroll > 0 ? el.scrollLeft / maxScroll : 0;
    var activeIdx = Math.round(progress * (numDots - 1));
    for (var j = 0; j < numDots; j++) {
      if (j === activeIdx) dots[j].classList.add('active');
      else dots[j].classList.remove('active');
    }
  }

  /* ── Equalizer: zarovná card-info výšky across karet ve stejném řádku ── */
  function eqCards() {
    if (window.innerWidth > 749) return;
    var cards = Array.from(document.querySelectorAll('product-card.card-product'));
    if (cards.length < 2) return;

    var sels = ['.card-info', '.ilico-variants-zone', '.card-footer-intro', '.price'];

    /* Reset */
    cards.forEach(function(c) {
      sels.forEach(function(s) {
        var el = c.querySelector(s);
        if (el) el.style.minHeight = '';
      });
    });

    /* Seskup do řádků dle Y pozice */
    var rows = [];
    cards.forEach(function(c) {
      var r = c.getBoundingClientRect();
      if (r.width < 10) return;
      var y = Math.round(r.top);
      var row = null;
      for (var i = 0; i < rows.length; i++) {
        if (Math.abs(rows[i].y - y) < 40) { row = rows[i]; break; }
      }
      if (!row) { row = { y: y, cards: [] }; rows.push(row); }
      row.cards.push(c);
    });

    /* Zarovnej výšky sekcí */
    rows.forEach(function(row) {
      var rc = row.cards;
      if (rc.length < 2) return;
      for (var si = 0; si < sels.length; si++) {
        var sel = sels[si];
        var maxH = 0, els = [], skip = false;
        rc.forEach(function(c) {
          var el = c.querySelector(sel);
          if (!el) { skip = true; return; }
          if (sel === '.ilico-variants-zone' && el.children.length < 1) { skip = true; return; }
          els.push(el);
          var h = el.offsetHeight;
          if (h > maxH) maxH = h;
        });
        if (!skip && maxH > 0 && els.length > 1) {
          els.forEach(function(el) { el.style.minHeight = maxH + 'px'; });
        }
      }
    });
  }

  function init() {
    wrapScrollable('.ilico-size-badges');
    wrapScrollable('.ilico-color-swatches');
    /* Po vytvoření scroll wrapperů spusť equalizaci */
    setTimeout(eqCards, 50);
    setTimeout(eqCards, 300);
    setTimeout(eqCards, 800);
    setTimeout(eqCards, 2000);
  }

  window.addEventListener('load', function() {
    setTimeout(init, 400);
  });
  /* Při lazy-load obrázcích může layout skočit — přepočítej */
  document.addEventListener('lazyloaded', function() {
    setTimeout(eqCards, 100);
  });
  window.addEventListener('resize', function() {
    document.querySelectorAll('.ilico-scroll-wrap').forEach(function(wrap) {
      var el = wrap.querySelector('.ilico-size-badges, .ilico-color-swatches');
      if (el) updateArrows(wrap, el);
    });
    setTimeout(eqCards, 200);
  });
})();

